import { forwardRef } from 'react';
import { getTestId } from '../../../utils/testId.js';
import { jsx } from 'react/jsx-runtime';

var StackItem = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var _ref$as = _ref.as,
    Component = _ref$as === void 0 ? 'div' : _ref$as,
    testId = _ref.testId,
    children = _ref.children,
    alignSelf = _ref.alignSelf,
    flex = _ref.flex,
    order = _ref.order;
  return /*#__PURE__*/jsx(Component, {
    "data-testid": getTestId(testId, 'flex-item'),
    ref: ref,
    style: {
      order: order,
      flex: flex,
      alignSelf: alignSelf
    },
    children: children
  });
});
StackItem.displayName = 'StackItem';

export { StackItem as default };
//# sourceMappingURL=StackItem.js.map
